import Tea from '@dp/byted-tea-sdk-oversea';
import { pick } from '../object';
import { DEFAULT_TEA_APP_ID } from '../constant';

const teaChannelConfig = {
  ROW: {
    channel: 'va' as const,
    channel_type: 'tcpy',
  },
  TTP: {
    channel: 'va' as const,
    channel_type: 'ttp',
  },
  'EU-TTP': {
    channel: 'ie' as const,
    channel_type: 'ttp',
  },
};

Tea.init({
  app_id: DEFAULT_TEA_APP_ID,
  log: false,
  ...teaChannelConfig[process.env.AWEME_REGION],
});
Tea.start();

export function setTeaConfig(attributes: Record<string, string>) {
  Tea.config({
    evtParams: attributes,
  });
}

export function teaReport(eventName: string, attributes = {}) {
  const referrer = `${location.protocol}//${location.host}${location.pathname}`;
  Tea.event(eventName, {
    page_url: referrer,
    host: location.host,
    user_agent: navigator.userAgent,
    referrer,
    ...attributes,
  });
}

export function monitorSelfErrors() {
  const selfSrc = (document.currentScript as HTMLScriptElement)?.src;
  if (selfSrc) {
    window.addEventListener('error', (e: Event) => {
      if (e instanceof ErrorEvent && e.filename === selfSrc) {
        const error = {
          ...pick(e.error, ['name', 'message', 'stack']),
          ...pick(e as unknown as Record<string, string>, ['filename', 'lineno', 'colno']),
        };
        teaReport('cookie_banner_js_error', error);
      }
    });
  }
}
